import { render, staticRenderFns } from "./ModalAddIsIdentificator.vue?vue&type=template&id=074bf73e&scoped=true&"
import script from "./ModalAddIsIdentificator.vue?vue&type=script&lang=js&"
export * from "./ModalAddIsIdentificator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074bf73e",
  null
  
)

export default component.exports